import { capitalAgGridTheme } from '@opengov/capital-ag-grid-theme';
import { LicenseManager } from 'ag-grid-enterprise';
import { AgGridReact, type AgGridReactProps } from 'ag-grid-react';

import React, { forwardRef, useMemo } from 'react';
import { ogGridTheme } from './ogGridTheme';

/* tslint:disable */
LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-064789}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{OpenGov_(USA,_CA,_San_Francisco,_94107)}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{OpenGov}_only_for_{35}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{OpenGov}_need_to_be_licensed___{OpenGov}_has_been_granted_a_Deployment_License_Add-on_for_{Unlimited}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{7_September_2025}____[v3]_[01]_MTc1NzE5OTYwMDAwMA==c9d2f239d0237b8c86a1c30e3b3f8d6e'
);
/* tslint:enable */

export interface IOgGridTableProps<TData = any> extends AgGridReactProps<TData> {
  gridContainerStyle?: React.CSSProperties;
  condensed?: boolean;
  /** Color mode for the grid. Defaults to 'light'. */
  colorMode?: 'light' | 'dark';
}

export const OgGridTable = forwardRef<AgGridReact, IOgGridTableProps<any>>(
  ({ gridContainerStyle = {}, condensed = false, colorMode = 'light', ...props }, ref) => {
    const theme = useMemo(() => {
      const base = condensed ? ogGridTheme.withParams({ spacing: 6 }) : ogGridTheme;
      if (colorMode === 'dark') {
        return base.withParams(capitalAgGridTheme({ condensed, mode: 'dark' }));
      }
      return base;
    }, [condensed, colorMode]);

    return (
      <div style={gridContainerStyle}>
        <AgGridReact ref={ref} {...props} theme={theme} />
      </div>
    );
  }
);
